import IconArrow from './IconArrow'

export default IconArrow